import { render, staticRenderFns } from "./DateComponent.vue?vue&type=template&id=c4ed36e8&scoped=true"
import script from "./DateComponent.vue?vue&type=script&lang=js"
export * from "./DateComponent.vue?vue&type=script&lang=js"
import style0 from "./DateComponent.vue?vue&type=style&index=0&id=c4ed36e8&prod&lang=scss&scoped=true"
import style1 from "./DateComponent.vue?vue&type=style&index=1&id=c4ed36e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ed36e8",
  null
  
)

export default component.exports